import React from 'react';
import './styles/VariantOptionsModal.css';

interface VariantOptionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

const VariantOptionsModal: React.FC<VariantOptionsModalProps> = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;
  return (
    <div className="variant-modal-overlay">
      <div className="variant-modal-content">
        <div className="variant-modal-header">
          <span className="variant-modal-title">{title}</span>
          <button className="variant-modal-close" onClick={onClose} aria-label="Close">&times;</button>
        </div>
        <div className="variant-modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default VariantOptionsModal;
